import { create, fromBinary, toBinary } from '@bufbuild/protobuf';
import { randomUUID } from '@/lib/uuid';
import { timestampNow } from '@bufbuild/protobuf/wkt';
import { generateTraceParent } from '@/lib/tracing';
import {
  type MessageEnvelope,
  MessageEnvelopeSchema,
  PingSchema,
} from './gen/envelope/envelope_pb';

export function createEnvelope(
  payload: MessageEnvelope['payload'],
  requestId?: string,
): MessageEnvelope {
  return create(MessageEnvelopeSchema, {
    requestId: requestId ?? randomUUID(),
    timestamp: timestampNow(),
    traceParent: generateTraceParent(),
    payload,
  });
}

export function createPingEnvelope(): MessageEnvelope {
  return createEnvelope({
    case: 'ping',
    value: create(PingSchema),
  });
}

export function serializeEnvelope(envelope: MessageEnvelope): Uint8Array {
  return toBinary(MessageEnvelopeSchema, envelope);
}

export function deserializeEnvelope(bytes: Uint8Array): MessageEnvelope {
  return fromBinary(MessageEnvelopeSchema, bytes);
}

export function getPayloadCase(envelope: MessageEnvelope): string | undefined {
  return envelope.payload.case;
}

export function getPayloadValue(envelope: MessageEnvelope): unknown {
  return envelope.payload.value;
}
